import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/common';
import { ROUTES } from '../../utils/constants';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 Illustration */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-primary-100 to-primary-200 rounded-full mb-6">
            <span className="text-6xl font-bold gradient-text">404</span>
          </div>
        </div>

        {/* Content */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4 font-display">
          Página não encontrada
        </h1>
        
        <p className="text-lg text-gray-600 mb-8">
          Desculpe, a página que você está procurando não existe ou foi movida.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            variant="outline"
            size="lg"
            onClick={() => navigate(-1)}
            leftIcon={<ArrowLeft className="w-5 h-5" />}
          >
            Voltar
          </Button>
          
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate(ROUTES.DASHBOARD)}
            leftIcon={<Home className="w-5 h-5" />}
          >
            Ir para Dashboard
          </Button>
        </div>

        {/* Help text */}
        <p className="text-sm text-gray-500 mt-8">
          Se você acha que isso é um erro, entre em contato com o{' '}
          <a href="/suporte" className="text-primary-600 hover:underline">
            suporte
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;